import api from './api';

const ValidateCellPhone = {
  check: (cellphone, cpf) => api.post('validate-cellphone', { cellphone, cpf }),
  generate: (cellphone, cpf ) => api.post('sms/token/generate', { cellphone, cpf }),
  validate: (tokenId, cpf) => api.post('sms/token/validate', { tokenId, cpf }),
};

export default ValidateCellPhone;
